import * as Types from "src/Constants";

const initialState: AppReducer = {
  currentPage: "INTRO_0",
  previousPage: "",
  notis: [1, 4, 6],
  showOptions: false,
};

type SetPageAction = { type: typeof Types.SET_CURRENT_PAGE; value: string };
type SetPreviousPageAction = { type: typeof Types.SET_PREVIOUS_PAGE; value: string };
type SetNotisAction = { type: typeof Types.SET_NOTIS; value: number[] };
type SetShowOptionsAction = { type: typeof Types.SET_SHOW_OPTIONS; value: boolean };

type AppReducerAction = SetPageAction | SetPreviousPageAction | SetNotisAction | SetShowOptionsAction;

export default function appReducer(state = initialState, action: AppReducerAction) {
  switch (action.type) {
    case Types.SET_CURRENT_PAGE:
      return { ...state, currentPage: action.value };
    case Types.SET_PREVIOUS_PAGE:
      return { ...state, previousPage: action.value };
    case Types.SET_NOTIS: {
      return { ...state, notis: action.value };
    }
    case Types.SET_SHOW_OPTIONS: {
      return { ...state, showOptions: action.value };
    }
    default:
      return state;
  }
}
